module.exports = __webpack_public_path__ + "static/media/002.8179dc07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/002.jpg
// module id = 299
// module chunks = 0